<div class="min-h-screen bg-cloud-mist font-sans flex flex-col">

  <main>
    <div class="tfr-page-shell-narrow py-10 sm:py-14 lg:py-16">
      <a routerLink="/" class="mb-8 inline-flex text-[13px] font-medium text-slate-blue transition-colors hover:text-midnight-indigo">
        ← Volver al inicio
      </a>

      <!-- Header -->
      <div class="mb-12">
        <span class="inline-flex items-center px-3 py-1 rounded-[50px] text-xs font-semibold tracking-wide
                     bg-pale-gray text-glacier-blue mb-5">Para propietarios de espacio</span>
        <h1 class="text-[38px] font-bold leading-[1.21] text-midnight-indigo mb-3">
          Términos y Condiciones<br>del Propietario de Espacio
        </h1>
        <p class="text-[14px] text-steel-gray">Última actualización: {{ updated }}</p>
      </div>

      <!-- Body -->
      <div class="space-y-10 text-[15px] leading-[1.71] text-slate-blue">

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">1. Quién es «Propietario de Espacio»</h2>
          <p>
            A efectos de estos Términos, es <strong class="text-midnight-indigo">Propietario de Espacio</strong>
            toda persona física o jurídica con capacidad legal para contratar que publica uno o más
            espacios en TimeFlexRent y acepta estos Términos específicos de forma expresa durante
            el proceso de alta.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">2. Obligaciones legales y administrativas</h2>
          <p>El Propietario declara y garantiza que:</p>
          <ul class="mt-3 space-y-2.5 list-none pl-0">
            <li class="flex gap-3">
              <span class="mt-2 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span>Dispone de todas las <strong class="text-midnight-indigo">licencias de actividad y apertura</strong> exigidas por la normativa municipal y autonómica que le sea de aplicación.</span>
            </li>
            <li class="flex gap-3">
              <span class="mt-2 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span>El aforo máximo publicado respeta el límite establecido en el <strong class="text-midnight-indigo">certificado de licencia de actividad</strong> o en las Instrucciones Técnicas del CGSE aplicables.</span>
            </li>
            <li class="flex gap-3">
              <span class="mt-2 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span>Cuenta con un <strong class="text-midnight-indigo">seguro de responsabilidad civil</strong> vigente que cubra daños a terceros en el espacio por un mínimo de 300.000 € por siniestro.</span>
            </li>
            <li class="flex gap-3">
              <span class="mt-2 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span>Cumple con la normativa de <strong class="text-midnight-indigo">protección contra incendios</strong> (extintores vigentes, señalización de emergencia, plan de evacuación visible).</span>
            </li>
            <li class="flex gap-3">
              <span class="mt-2 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span>Si el espacio se destina parcial o totalmente a <strong class="text-midnight-indigo">actividades con menores</strong>, cumple con la Ley Orgánica de Protección Integral a la Infancia y la Adolescencia (LOPIVI) y dispone de los certificados de delitos sexuales del personal.</span>
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">3. Responsabilidad por el espacio físico</h2>

          <!-- Responsibility card -->
          <div
               class="p-5 rounded-2xl border border-pale-gray bg-white mb-4 shadow-tfr-md">
            <p class="text-[13px] font-semibold text-midnight-indigo mb-2">Principio de responsabilidad exclusiva</p>
            <p class="text-[13px]">
              TimeFlexRent actúa únicamente como intermediario tecnológico. El Propietario asume
              <strong class="text-midnight-indigo">responsabilidad exclusiva</strong> sobre: el estado
              estructural y de mantenimiento del espacio, la seguridad de las instalaciones eléctricas,
              de fontanería y de gas, los daños personales o materiales derivados del uso del espacio,
              y el cumplimiento de la normativa de accesibilidad (Real Decreto 505/2007).
            </p>
          </div>

          <p>
            TimeFlexRent no será responsable en ningún caso de reclamaciones de clientes relacionadas
            con el estado del espacio, lesiones, accidentes o incumplimiento de las condiciones
            publicitadas. El Propietario se obliga a mantener indemne a TimeFlexRent frente a
            cualquier reclamación de terceros derivada de lo anterior.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">4. Política de cancelación y reembolsos</h2>
          <p>
            Las políticas de cancelación y modificación son responsabilidad exclusiva del propietario del espacio. TimeFlexRent actúa únicamente como intermediario tecnológico.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">5. Comisiones y facturación</h2>
          <p>
            TimeFlexRent aplica una <strong class="text-midnight-indigo">comisión de servicio</strong> sobre
            cada reserva confirmada, cuyo porcentaje vigente se comunica al Propietario en el momento
            de alta y puede consultarse en el panel de control. La comisión indicada incluye el IVA
            aplicable y TimeFlexRent emite su factura al Propietario, aplicando la retención fiscal
            que corresponda según los datos declarados por ambas partes.
          </p>
          <p class="mt-3">
            En modalidad de cobro manual, el Cliente abona a TimeFlexRent la comisión online y paga
            directamente al Propietario el saldo del alquiler. En modalidad Stripe Connect, Stripe
            procesa el alquiler para la cuenta conectada del Propietario y separa la comisión de
            TimeFlexRent.
          </p>
          <p class="mt-3">
            El Propietario es el único responsable de emitir al Cliente cualquier factura o documento
            fiscal correspondiente al alquiler mediante sus propios sistemas. TimeFlexRent no emite,
            contabiliza ni conserva esa factura por cuenta del Propietario.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">6. Contenido publicado</h2>
          <p>
            El Propietario garantiza que las fotografías, descripciones y precios publicados son
            veraces y no inducen a error. TimeFlexRent se reserva el derecho de eliminar sin previo
            aviso cualquier listado que incumpla estas condiciones, que vulnere derechos de terceros
            o que infrinja la normativa vigente.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">7. Suspensión y baja de cuenta</h2>
          <p>
            TimeFlexRent podrá suspender o dar de baja al Propietario de forma inmediata si:
            (i) se detectan incumplimientos graves de estos Términos; (ii) el Propietario acumula
            una tasa de cancelación superior al 15 % en 90 días; o (iii) recibe valoraciones
            medias inferiores a 2/5 durante 30 días consecutivos. En caso de suspensión, las
            reservas activas se respetarán y gestionarán hasta su finalización.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">8. Legislación aplicable</h2>
          <p>
            Estos Términos se rigen por la legislación española. Para cualquier controversia,
            las partes se someten a los Juzgados y Tribunales competentes conforme a la
            legislación española. Antes de acudir a la vía judicial, ambas partes se comprometen a intentar
            una resolución amistosa en un plazo de 30 días desde la notificación escrita del conflicto.
          </p>
        </section>

      </div>

      <!-- Footer actions -->
      <div class="mt-14 pt-8 border-t border-pale-gray flex flex-col sm:flex-row items-start sm:items-center gap-5 justify-between">
        <a routerLink="/"
           class="inline-flex items-center gap-2 text-[13px] font-medium text-slate-blue
                  hover:text-midnight-indigo transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
          Volver al inicio
        </a>
        <a routerLink="/terminos"
           class="text-[13px] font-medium text-action-blue hover:underline transition-colors">
          Ver Términos Generales →
        </a>
      </div>

    </div>
  </main>

  <app-site-footer />

</div>
